import { PRICING_FACTS, type BillingPeriod } from "@/lib/plans";
import styles from "./BillingPeriodToggle.module.css";

export function BillingPeriodToggle({
  value,
  onChange,
}: {
  value: BillingPeriod;
  onChange: (next: BillingPeriod) => void;
}) {
  return (
    <div
      className={styles.toggle}
      role="radiogroup"
      aria-label="Billing period"
    >
      {(["monthly", "yearly"] as const).map((period) => (
        <button
          key={period}
          type="button"
          role="radio"
          aria-checked={value === period}
          className={`${styles.option} ${value === period ? styles.active : ""}`}
          onClick={() => onChange(period)}
        >
          {period === "monthly" ? "Monthly" : "Yearly"}
          {period === "yearly" && (
            <span className={styles.save}>
              −{PRICING_FACTS.yearlyDiscountPercent}%
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
